<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
      <template>
        <v-row>
          <v-col cols="4">
            <v-select
              v-model="idAux"
              :items="bonoActivo"
              placeholder="Bono"
              item-text="nombre"
              item-value="id"
              outlined
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="montoAux"
              outlined
              type="number"
              placeholder="Monto"
              hide-details
              prefix="S/"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn tile color="success" @click="añadirBono(idAux, montoAux)">
              <v-icon left>
                mdi-plus
              </v-icon>
              Agregar
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          cols="12"
          v-for="itemcito of muestraBonos"
          v-bind:key="itemcito.id"
          style="display: flex;align-items: center;"
        >
          <v-col cols="4">
            <span>{{ itemcito.nombre }}</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              :value="itemcito.monto"
              outlined
              type="number"
              hide-details
              prefix="S/"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn
              tile
              color="red"
              style="color:white;text-align: center;"
              @click="eliminarBono(itemcito.id)"
            >
              <v-icon left>
                mdi-minus-circle
              </v-icon>
              eliminar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cerrar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn dark color="success" block height="40" @click="handleStore">
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <!--<v-btn v-if="action == 'update'" dark color="success" block height="40" @click="handleUpdate">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Actualizar
                        </v-btn>-->
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ListarBonos",
  data() {
    return {
      idAux: null,
      montoAux: null,
      drawer: false,
      titleForm: null,
      action: null,
      muestraBonos: [],
      auxEmpleado: [],
      totalBonos: null,
    };
  },
  computed: {
    ...mapState("bonos", ["bonoActivo", "bonoSelected"]),
  },
  methods: {
    ...mapActions("bonos", ["store", "update"]),
    ...mapActions("planillaDetalle", [
      "actualizaEmpleado",
      "getItems",
      "actualizaBonoEmpleado",
    ]),
    async showForm(title, item) {
      this.muestraBonos = [];
      this.auxEmpleado = item;
      let obser = item.bonos;
      let areglo = null;
      if (obser == null) {
        this.muestraBonos = [];
      } else {
        if (typeof obser === "string") {
          this.muestraBonos = JSON.parse(obser);
        } else {
          this.muestraBonos = obser;
        }
      }
      // console.log(areglo);
      this.totalBonos = item.totalBonos;
      this.titleForm = title;
      this.drawer = !this.drawer;
    },
    eliminarBono(id) {
      this.totalBonos = 0;
      let agrego = [];
      agrego = this.muestraBonos;
      this.muestraBonos = [];
      for (let i = 0; i < agrego.length; i++) {
        if (agrego[i].id != id) {
          this.totalBonos =
            parseFloat(this.totalBonos) + parseFloat(agrego[i].monto);
          this.muestraBonos.push(agrego[i]);
        } else {
          let totalAct =
            parseFloat(this.auxEmpleado.totalPagar) -
            parseFloat(agrego[i].monto);
          this.auxEmpleado.totalPagar = parseFloat(totalAct).toFixed(2);
        }
      }
    },
    añadirBono(id, monto) {
      for (let i = 0; i < this.bonoActivo.length; i++) {
        if (this.bonoActivo[i].id == id) {
          const element = {
            id: id,
            nombre: this.bonoActivo[i].nombre,
            monto: monto,
          };
          this.totalBonos = parseFloat(this.totalBonos) + parseFloat(monto);
          this.muestraBonos.push(element);
          let totalAct =
            parseFloat(this.auxEmpleado.totalPagar) + parseFloat(monto);
          this.auxEmpleado.totalPagar = parseFloat(totalAct).toFixed(2);
        }
      }
      this.idAux = null;
      this.montoAux = null;
    },
    async handleStore() {
      this.auxEmpleado.bonos = this.muestraBonos;
      this.auxEmpleado.totalBonos = this.totalBonos;
      // console.log(this.auxEmpleado);
      this.actualizaBonoEmpleado(this.auxEmpleado);
    },
    closeForm() {
      this.drawer = false;
    },
    handleCancel() {
      this.closeForm();
    },
  },
};
</script>

<style scoped></style>
